_setUserLocalDataLanguageAlertBarAccepted